import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import CartCard from "../../components/cartCard/CartCard";
import PlansCard from "../../components/plansCard/PlansCard";
import ProductCard from "../../components/prodCard/ProductCard";
import { useCheckout } from "../../context/CheckoutContext";
import ApiService from "../../service/ApiService";
import styles from "./Carrinho.module.css";
import { Constants } from "../../utils/constants";
import { Header } from "../../components/Header";
import { filterAndSelectProducts } from "../../helpers/ProductsFilter";
import General from "../../helpers/General";
import { useAppLocalStorage } from "../../hook/localStorage";
import { ecommerceEvents } from '../../utils/gtm';

const apiService = new ApiService();
const Carrinho: FunctionComponent = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [urlCouponCalls, setUrlCouponCalls] = useState(1);
  const [clientAndAffiliateCalls, setClientAndAffiliateCalls] = useState(false);
  const [searchParams] = useSearchParams();

  const fetchProductDetails = async ({
    id,
    price,
    credit_tax,
    debit_tax,
    cred_anual_tax,
    plans_id,
    products_id,
    order,
    index,
    normal_price
  }: {
    id: number;
    order: number
    plans_id: string;
    price: string;
    credit_tax: string;
    debit_tax: string;
    cred_anual_tax: string;
    products_id: number;
    index: number;
    normal_price: number;
  }) => {
    try {
      const product = await apiService.getProductDetails(products_id);
      product.price = price;
      product.credit_tax = credit_tax;
      product.debit_tax = debit_tax;
      product.cred_anual_tax = cred_anual_tax;
      product.plans_id = plans_id;
      product.products_id = products_id;
      product.order = order ? order : index;
      product.normal_price = normal_price
      return product;
    } catch (error) {
      // Lide com erros, por exemplo, exibindo uma mensagem de erro
      console.error(
        `Erro ao buscar detalhes para o produto com ID ${id}: ${error.message}`
      );
      return null; // Ou outra ação adequada em caso de erro
    }
  };

  const {
    clientAndAffiliate,
    setClientAndAffiliate,
    cart,
    planId,
    setPlanId,
    setPlanName,
    coupon,
    setCoupon,
    totalPrice,
    setTotalPrice,
    planName
  } = useCheckout();
  const [selectedComponent, setSelectedComponent] = useState(0);
  const [allPlans, setAllplans] = useState([]);
  const [allProducts, setAllProducts] = useState<any[]>([]);
  const [isCartCardVisible, setIsCartCardVisible] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState();
  const cartCardRef = useRef(null);
  const [disclaimer, setDisclaimer] = useState();

  const width = window.innerWidth;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartCardRef.current && !cartCardRef.current.contains(event.target)) {
        setIsCartCardVisible(false);
      }
    };

    if (isCartCardVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCartCardVisible]);

  const openCartCardModal = () => {
    setIsCartCardVisible(!isCartCardVisible);
  };
  const handleSelectPlan = useCallback((compName: number, id: number) => {
    let products;
    setAllProducts([]);
    setSelectedComponent(compName);
    apiService.getAllProductPlans().then(async (res) => {
      if (res) {
        if (id === 0) id = allPlans[0]?.id
        const allProdPlans = res.filter((plan: any) => plan.plans_id === id);
        const filterProdPlans = filterAndSelectProducts(allProdPlans, clientAndAffiliate.affiliate_id)
        const promises = filterProdPlans.map(async (plan: any, index: number) =>{
          const test = await fetchProductDetails({...plan, id: plan.products_id, index: index + 1, normal_price: plan.normal_price})

          return {
            ...test,
            commissionType: plan.commissionType,
            commissionValue: plan.commissionValue,
          }
        }
        );
        try {
          products = await Promise.all(promises);
          setAllProducts(products.sort((a, b) => a.order - b.order));
        } catch (error: any) {
          console.error(`Erro ao buscar detalhes dos produtos: ${error.message}`);
        }
      }
    }).then(() => {
      if (id && compName) {
        const planName = allPlans.find((plan) => plan.id === id).name;
    
        ecommerceEvents.viewPromotion({
          currency: "BRL",
          value: totalPrice,
          coupon: coupon.name ? coupon.name : "",
          afiliado: params.slug
            ? params.slug
            : clientAndAffiliate.affiliate_id
            ? clientAndAffiliate.affiliate_id
            : "",
          promotion_id: id,
          promotion_name: planName,
          items: products.map((item: any) => ({
            item_id: item.id,
            item_name: item.name,
            price: item.price,
            promotion_id: id,
            promotion_name: planName,
          })),
        })
      }
    })


    
  }, [allPlans, clientAndAffiliate.affiliate_id]);

  useEffect(() => {
    const id = clientAndAffiliate.client_id;
    if (id === undefined) return
    apiService.getAllPlans(id)
      .then((res) => setAllplans(res.filter((plan) => plan.client_id === id )));
  }, [clientAndAffiliate]);

  useEffect(() => {
    if (planId === "" && allPlans.length > 0) {
      const firstPlan = allPlans.sort((a, b) => a.order - b.order)[0]
      setPlanId(firstPlan.id)
      setPlanName(firstPlan.name)
    }
    handleSelectPlan(0, 0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allPlans, handleSelectPlan, setPlanId]);

  const couponURL = searchParams.get('cupom');
  useEffect(() => {
    apiService.getTermsAndPolicy().then((res) => {
      setDisclaimer(res.image_disclaimer_text);
    })
    const clientDomain = window.location.hostname;
    const affiliate = params.slug;
    const { planSlug, productSlug } = params;
    if (affiliate && productSlug && planSlug) {
      return navigate(
        `/checkout-dados/${affiliate}/${planSlug}/${productSlug}${
          couponURL ? `?cupom=${couponURL}` : ''
        }`
      );
    } else if (productSlug && planSlug) {
      return navigate(`/checkout-dados/${planSlug}/${productSlug}${
        couponURL ? `?cupom=${couponURL}` : ''
      }`);

    }


    if (affiliate && affiliate !== 'Pendente') {
      apiService.getAffiliateDetails(affiliate).then((affi) => {
        if (clientDomain.includes("yelly") || clientDomain.includes("localhost")) {
          document.title = `Checkout Yelly`;
          localStorage.setItem(
            Constants.LOCALSTORAGE.app,
            JSON.stringify(affi)
          );
          setClientAndAffiliate({
            client_id: null,
            affiliate_id: affi.client_id === null ? affi.id : null,
            commissionValue: affi.commissionValue,
            commissionType: affi.commissionType,
            slug: affi.slug
          });
          setClientAndAffiliateCalls(true);
        } else {
          apiService.getClientDetails(clientDomain).then((res) => {
            document.title = `Checkout ${res.name}`;
            localStorage.setItem(
              Constants.LOCALSTORAGE.app,
              JSON.stringify(res)
            );
            setClientAndAffiliate({
              client_id: res.id,
              affiliate_id: affi.client_id === res.id ? null : affi.id,
              commissionValue: affi.commissionValue,
              commissionType: affi.commissionType,
              slug: affi.slug,
            });
            setClientAndAffiliateCalls(true);
          });
        }
      });
    } else {
      if (clientDomain.includes("yelly") || clientDomain.includes("localhost")) {
        document.title = `Checkout Yelly`;
        localStorage.removeItem(Constants.LOCALSTORAGE.app);
        setClientAndAffiliate({ client_id: null, affiliate_id: null });
        setClientAndAffiliateCalls(true);
      } else {
        apiService.getClientDetails(clientDomain).then((res) => {
          document.title = `Checkout ${res.name}`;
          localStorage.setItem(
            Constants.LOCALSTORAGE.app,
            JSON.stringify(res)
          );
          setClientAndAffiliate({
            client_id: res.id,
            affiliate_id: null,
          });
          setClientAndAffiliateCalls(true);
        });
      }
    }
  }, [params.slug, setClientAndAffiliate]);

  useEffect(() => {
    if (cart.length > 0) {
      setSelectedPlan(cart[0].id.split('_')[1]);
    } else {
      setSelectedPlan();
    }
  }, [cart])

  useEffect(() => {
    ecommerceEvents.beginCheckout({
      currency: "BRL",
      value: totalPrice,
      coupon: coupon.name ? coupon.name : "",
      afiliado: params.slug
        ? params.slug
        : clientAndAffiliate.affiliate_id
        ? clientAndAffiliate.affiliate_id
        : "",
      items: cart.map(item => ({
        item_id: item.id,
        item_name: item.title,
        price: item.price,
        quantity: item.quantity,
      })),
    });
  }, []);

  const { app } = useAppLocalStorage();

  useEffect(() => {
    // cupom mobile
    if(couponURL &&
      width < 800
    ) {
      const customIdToast = "coupon-message";
      if (urlCouponCalls === 1 && clientAndAffiliateCalls) {
        apiService.getCoupon(couponURL).then((response) => {
          const couponValidation =
            General.couponValidation(
              response, totalPrice, clientAndAffiliate.affiliate_id || app?.id
            );
          if (
            couponValidation.couponUnavailable
            || couponValidation.couponLimitReached
            || couponValidation.nonExistentCoupon
            || couponValidation.inactiveCoupon
            || couponValidation.expiredCoupon
          ) {
            const message =
              'Este cupom não pertence a esta URL ou não está mais válido.';
            setCoupon({ name: couponURL, found: response, message });
          }
          if(
            couponURL &&
            !couponValidation.couponUnavailable
            && !couponValidation.couponLimitReached
            && !couponValidation.nonExistentCoupon
            && !couponValidation.inactiveCoupon
            && !couponValidation.expiredCoupon 
            && (
              couponValidation.purchaseBelowTheMinimumValue
              || couponValidation.totalValueGreaterThanTheMaximumDiscountValue
            )
          ) {
            const { min_purchase_value, discount_type, discount_value }
              = response;
            const value =
              discount_type === 1
                ? parseFloat(min_purchase_value) > parseFloat(discount_value)
                  ? min_purchase_value
                  : discount_value
                : min_purchase_value;
            const message =
              `Cupom inserido, mas não validado. Para utilizá-lo,
              selecione produtos que somados tenham um valor acima de R$
              ${parseFloat(value).toFixed(2).replace('.', ',')}`
            setCoupon({
              name: couponURL, found: response, message,
            });
          }
          if (couponValidation.validatedCoupon) {
            setCoupon({ ...coupon, found: response, message: "" });
          }

          setUrlCouponCalls((prevState) => prevState + 1);
        });
      }

        const sumTotal = cart.reduce((acc, prods) => {
          return acc + prods.price * prods.quantity;
        }, 0);
        const couponValidation =
          General.couponValidation(
            coupon.found, sumTotal, clientAndAffiliate.affiliate_id
          )

        if(couponValidation.validatedCoupon) {
          const total = coupon.found?.discount_type === 0
          ? Number(
              General.formatCurrency(
                sumTotal *
                (1 - (parseInt(coupon.found.discount_value) / 100))
              ).replace(/,/g, '')
            )
          : Number(
              General.formatCurrency(
                sumTotal -
                parseInt(coupon.found.discount_value)
              ).replace(/,/g, '')
            );
          setTotalPrice(total);
          if(toast.isActive(customIdToast)) {
            toast.update(customIdToast, {
              render: 'Cupom de desconto aplicado',
              type: 'success',
            })
          } else {
            toast.success('Cupom de desconto aplicado', {
              toastId: customIdToast
            })
          }
        } else {
          const total = parseFloat(sumTotal.toFixed(2));
          setTotalPrice(total);
          if(toast.isActive(customIdToast)) {
            toast.update(customIdToast, {
              render: coupon.message,
              type: 'error',
            })
          } else {
            toast.error(coupon.message, {
              toastId: customIdToast,
            })
          }
        }
    }
  }, [
    couponURL,
    clientAndAffiliate,
    width,
    urlCouponCalls,
    clientAndAffiliateCalls,
    totalPrice,
    setCoupon,
    coupon,
    cart,
    setTotalPrice,
  ])

  useEffect(() => {
    if (cart.length > 0) {
      ecommerceEvents.selectPromotion({
        currency: "BRL",
        value: totalPrice,
        coupon: coupon.name? coupon.name : "",
        promotion_id: planId,
        promotion_name: planName,
        afiliado: params.slug? params.slug : clientAndAffiliate.affiliate_id? clientAndAffiliate.affiliate_id : "",
        items: cart.map(item => ({
          item_id: item.id,
          item_name: item.name,
          price: item.price,
          quantity: item.quantity,
          promotion_id: planId,
          promotion_name: planName,
        })),
      });
    }
  }, [cart])

  const handleContinueClick = () => {
    params.slug 
      ? navigate(`/checkout-dados/${params.slug}${couponURL ? `?cupom=${couponURL}` : ''}`)
      : navigate(`/checkout-dados${couponURL ? `?cupom=${couponURL}` : ''}`);
  };

  return (
    <div className={styles.carrinho}>
      <div className={styles.conteudo}>
        <Header />
        <div className={styles.conteudoCarrinhoProduto}>
          <div className={styles.colunaDireita}>
            <div className={styles.tipoDePlano}>Escolha seu plano</div>
            <div className={styles.planos}>
              {
                allPlans?.sort((a, b) => a.order - b.order).map((plan, index) => {
                let disable = false;
                if (!selectedPlan) disable = false
                else if (plan.id !== parseInt(selectedPlan)) disable = true

                return (<PlansCard
                    key={plan.id}
                    index={index}
                    selected={selectedComponent === index}
                    onSelect={handleSelectPlan}
                    title={plan.name}
                    id={plan.id}
                    text=""
                    disabled={disable} />)
              })}
            </div>
            <div className={styles.tipoDePlano}>Escolha sua máquina</div>
            {allProducts.length > 0 ? (
              allProducts?.map((prod) => (
                <ProductCard
                  key={prod.id}
                  title={prod.name}
                  img={prod.image}
                  text={prod.description}
                  price={prod.price}
                  credit_tax={prod.credit_tax}
                  debit_tax={prod.debit_tax}
                  cred_anual_tax={prod.cred_anual_tax}
                  id={`${prod.products_id}_${prod.plans_id}`}
                  products_id={prod.products_id}
                  normal_price={prod.normal_price}
                  setBtnDisable={setBtnDisable}
                  commissionType={prod.commissionType}
                  commissionValue={prod.commissionValue}
                  description={prod.description}
                />
              ))
            ) : (
              <p>Não foi encontrado nenhum produto</p>
            )}
            <div className={styles.imagensMeramenteIlustrativas}>
              {
                disclaimer
              }
            </div>
          </div>
          {width > 800 ? (
            <CartCard
              path="/checkout-dados"
              showProducts
              couponURL={couponURL}
            />
          ) : (
            <>
              <div className={styles.cartIconBox} onClick={openCartCardModal}>
                <svg
                  className={styles.cartIcon}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  width="27"
                  viewBox="0 0 576 512"
                >
                  <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
                </svg>
              </div>
              <div className={btnDisable ? styles.cta : styles.filledCart} 
              onClick={() =>  params.slug ? 
              navigate(`/checkout-dados/${ params.slug }${couponURL ? `?cupom=${couponURL}` : ''}`) 
              : navigate(`/checkout-dados${couponURL ? `?cupom=${couponURL}` : ''}`)}>
                <div className={styles.continuarCompra24}>
                  <button
                    className={styles.btnContinuarCompra}
                    disabled={btnDisable}
                    onClick={handleContinueClick}
                  >
                    Continuar a compra
                  </button>
                </div>
                <img className={styles.icones133} alt="" src="/icones5.svg" />
              </div>
            </>
          )}

          {isCartCardVisible && width < 800 && (
            <div
              className={`${styles.cartCardModal} ${
                isCartCardVisible ? styles.showModal : ""
              }`}
            >
              <div className={styles.cartCardContent} ref={cartCardRef}>
                <CartCard
                  path="/checkout-dados"
                  showProducts
                  couponURL={couponURL}
                />
                <div className={styles.cta1} onClick={openCartCardModal}></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Carrinho;
